import React, { Component } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';

import { TriggerOnScroll } from '../../../elements';
import BaeApiCard from '../../../bae/BaeApiCard';
import apis from './Apis.module.scss';
import b2b from '../../../styles/icon/card/b2b.svg';
import business from '../../../styles/icon/card/business.svg';
import card from '../../../styles/icon/card/card.svg';
import user from '../../../styles/icon/card/user.svg';
import userCheck from '../../../styles/icon/card/user-check.svg';
import calendar from '../../../styles/icon/card/calendar.svg';
import transfer from '../../../styles/icon/card/transfer.svg';
// import Routes from "../../../components/Routes";
import { getStatusPageSummary, getStatusPageSummaryForProd } from '../../../redux/env/envActions';
import strings from '../../../lang/lang';

function getIconName(type) {
  switch (type) {
    case 'partner-prepaid-cards':
      return b2b;
    case 'partner-accounts':
      return business;
    case 'accounts':
      return card;
    case 'kyc':
      return user;
    case 'salary':
      return userCheck;
    case 'transfers':
      return calendar;
    case 'cards':
      return transfer;
    default:
      return b2b;
  }
}

class Apis extends Component {
  constructor(props) {
    super(props);
    this.state = { summaryStatusPage: false };
  }

  // async

  componentDidMount() {
    getStatusPageSummary().then((res) => {
      const summaryStatusPage = res.data;
      this.setState({ summaryStatusPage });
    });
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    const { isProdSwitcherOpen } = this.props;
    if (prevProps.isProdSwitcherOpen !== isProdSwitcherOpen) {
      let getStatusFunc;
      if (isProdSwitcherOpen) {
        getStatusFunc = getStatusPageSummaryForProd();
      } else {
        getStatusFunc = getStatusPageSummary();
      }
      getStatusFunc.then((res) => {
        const summaryStatusPage = res.data;
        this.setState({ summaryStatusPage });
      });
    }
  }

  capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  getStatus = (availability, statusPageId) => {
    const { summaryStatusPage } = this.state;
    switch (availability) {
      case 'AVAILABLE':
        return summaryStatusPage.components.filter((item) => item.id === statusPageId).length > 0
          ? this.capitalize(
              summaryStatusPage.components.filter((item) => item.id === statusPageId)[0].status
            ).replace('_', ' ')
          : 'Major outage';
      case 'COMING_SOON':
        return 'Coming soon';
      case 'SANDBOX_ONLY':
        const pages = summaryStatusPage.components.filter((item) => item.id === statusPageId);
        const nextPages =
          pages.length > 0 ? this.capitalize(pages[0].status).replace('_', ' ') : 'Major outage';
        return pages.length > 0 && pages[0].status.toLowerCase() === 'operational'
          ? 'Sandbox only'
          : nextPages;
      default:
        return 'Coming soon';
    }
  };

  render() {
    const { isPageAnimationsUnblocked, apiList } = this.props;

    return (
      <div className={apis.apis} id="api-main">
        <TriggerOnScroll WrapperNode={null} bypass={!isPageAnimationsUnblocked} bottomOffset="30%">
          {({ enteredClassName }) => (
            <div
              className={cn(
                apis.apis__container,
                apis['apis__container--animate'],
                enteredClassName
              )}
            >
              <div className={apis.apis__box}>
                <h2>APIs</h2>
                <p>{strings.landingPage.apis.text.description}</p>
              </div>
              <div className={apis.apis__list}>
                {apiList.map((item, index) => {
                  return (
                    <div key={index} className={apis.apis__item}>
                      <a href={`/docs/apis/${item.id}`} rel="noopener noreferrer">
                        <BaeApiCard
                          icon={getIconName(item.id)}
                          head={item.headerName}
                          desc={item.scopeDescription.mainPage}
                          status={
                            this.state.summaryStatusPage &&
                            this.getStatus(item.availability, item.statusPageId)
                          }
                          enteredClassName={enteredClassName}
                          hasAnimation
                        />
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </TriggerOnScroll>
      </div>
    );
  }
}

const mapState = (state) => {
  return {
    isProdSwitcherOpen: state.prodSwitcher.isProdSwitcherOpen,
  };
};

export default connect(mapState)(Apis);
